import axios from 'axios'
import { Toast } from 'vant';
import router from "@/router";

// create an axios instance
const service = axios.create({
    baseURL: 'api', // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        if (localStorage.getItem("token")) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['token'] = localStorage.getItem("token")
        }

        // if (sessionStorage.getItem('userName')) {
        //     // let each request carry token
        //     // ['X-Token'] is a custom headers key
        //     // please modify it according to the actual situation
        //     config.headers['userName'] = sessionStorage.getItem('userName')
        // }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (res.result && res.result !== 1) {

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.result === -9 ) {
                // to re-login
                Toast({message:'登录失效,请重新登录！'});
            }
            return Promise.reject(res)
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        Toast(error.result);
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js